const blankCorporation = {
  steel: 0,
  titanium: 0,
  plants: 0,
  energy: 0,
  heat: 0,
  moneyProduction: 0,
  steelProduction: 0,
  titaniumProduction: 0,
  plantsProduction: 0,
  energyProduction: 0,
  heatProduction: 0,
  startingCards: 0,
  effect: null,
  action: null,
};

const corporationsDataList = [
  {
    name: 'Credicor',
    symbol: '🏦',
    color: 'purple',
    outline: 'purple',
    bgColor: 'white',
    money: 57,
    text: 'You start with 57 MC. | Effect: After you pay for a card or standard project with a basic cost of 20MC or more, you gain 4MC',
  },
  {
    name: 'Phobolog',
    symbol: '👽',
    color: 'white',
    outline: 'white',
    bgColor: 'navy',
    money: 23,
    titanium: 10,
    text: 'You start with 10 titanium and 23 MC. | Effect: Your titanium resources are each worth 1 MC extra.',
  },
  {
    name: 'Teractor',
    symbol: '🌎',
    color: 'orange',
    outline: 'orange',
    bgColor: '#444',
    money: 60,
    text: 'You start with 60 MC. | Effect: When playing an Earth card, you pay 3 MC less for it.',
  },
  {
    name: 'Interplanetary Cinematics',
    symbol: '🎥',
    color: 'yellow',
    outline: 'yellow',
    bgColor: 'orangered',
    money: 30,
    steel: 20,
    text: 'You start with 20 steel and 30 MC. | Effect: Each time you play an event, you gain 2 MC.',
  },
  {
    name: 'Ecoline',
    symbol: '🌿',
    color: 'green',
    outline: 'green',
    bgColor: 'white',
    money: 36,
    plants: 3,
    plantsProduction: 2,
    text: 'You start with 2 plant production, 3 plants and 36 MC. | Effect: You may always pay 7 plants, instead of 8, to place greenery.',
  },
  {
    name: 'Helion',
    symbol: '🔥',
    color: 'black',
    outline: 'black',
    bgColor: 'yellow',
    money: 42,
    heatProduction: 3,
    text: 'You start with 3 heat production and 42 MC. | Effect: You may use heat as MC. You may not use MC as heat.',
  },
  {
    name: 'Inventrix',
    symbol: '🔬',
    color: 'navy',
    outline: 'navy',
    bgColor: 'dodgerblue',
    money: 45,
    startingCards: 3,
    text: 'As your first action in the game, draw 3 cards. Start with 45 MC. | Effect: Your temperature, oxygen and ocean requirements are +2 or -2 steps, your choice in each case.',
  },
  {
    name: 'Mining Guild',
    symbol: '⛏️',
    color: '#333',
    outline: '#333',
    bgColor: 'orange',
    money: 30,
    steel: 5,
    steelProduction: 1,
    text: 'You start with 30 MC, 5 steel and 1 steel production. | Effect: Each time you get any steel or titanium as a placement bonus on the map, increase your steel production 1 step.',
  },
  {
    name: 'Saturn Systems',
    symbol: '🪐',
    color: 'white',
    outline: 'white',
    bgColor: 'navy',
    money: 42,
    titaniumProduction: 1,
    text: 'You start with 1 titanium production and 42 MC. | Effect: Each time any Jovian tag is put into play, including this, increase your MC production 1 step.',
  },
  {
    name: 'Tharsis Republic',
    symbol: '🏛️',
    color: '#333',
    outline: '#333',
    bgColor: 'orangered',
    money: 40,
    text: 'You start with 40 MC. As your first action in the game, place a city tile. | Effect: When any city tile is placed ON MARS, increase you MC production 1 step. When you place a city tile, gain 3 MC.',
  },
  {
    name: 'Thorgate',
    symbol: '🔌',
    color: 'navy',
    outline: 'navy',
    bgColor: 'firebrick',
    money: 48,
    energyProduction: 1,
    text: 'You start with 1 energy production and 48 MC. | Effect: When playing a power card OR THE STANDARD PROJECT POWER PLANT, you pay 3 MC less for it.',
  },
  {
    name: 'United Nations Mars Initiative',
    symbol: '🌐',
    color: 'white',
    outline: 'white',
    bgColor: 'dodgerblue',
    money: 40,
    text: 'You start with 40 MC. | Action: If your Terraforming Rating was raised this generation, you may pay 3 MC to raise it 1 step more.',
  },
  {
    name: 'Beginner Corporation',
    symbol: '🏢',
    color: 'black',
    outline: 'black',
    bgColor: '#ccc',
    money: 42,
    startingCards: 10,
    text: 'You start with 42 MC. Instead of choosing from 10 cards during setup, you get 10 cards for free.',
  },
];

export const getCorporation = (corporationName) => {
  const corporation = corporationsDataList.find(
    (corporation) => corporation.name === corporationName
  );

  return {
    ...blankCorporation,
    ...corporation,
  };
};

export const corporations = corporationsDataList.map((corporation) =>
  getCorporation(corporation.name)
);

export const corporationMap = corporations.reduce(
  (corporationAccumulator, corp) => {
    const key = corp.name.toLowerCase().replace(/\s/g, '-');
    corporationAccumulator[key] = corp;
    return corporationAccumulator;
  },
  {}
);
